import Tipo1 from './Tipo1';
export default Tipo1;